module.exports = __webpack_public_path__ + "static/media/img13.a181e239.jpg";